const debug = {
  log(...message) {
    if (!this.getDebugMode()) return;
    console.log(...message);
  },
  setDebugMode() {
    if (typeof localStorage === 'undefined') return;
    if (!window.location.search.includes('debug')) return;

    const debugMode = new URLSearchParams(window.location.search).get('debug');
    localStorage.setItem('debug-wk-popups', debugMode);
  },
  getDebugMode() {
    if (typeof localStorage === 'undefined') return false;

    return localStorage.getItem('debug-wk-popups') === 'true';
  }
}

debug.setDebugMode();

export default debug;





// WEBPACK FOOTER //
// ./src/utils/debug.js